var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isMapOff && _vm.showMap),expression:"!isMapOff && showMap"}],staticClass:"google-maps-overlay-container",class:{ 'fade-in': _vm.shouldShow, 'fade-out': !_vm.shouldShow }},[_c('a',{attrs:{"href":_vm.linkToMaps,"target":"_blank"}},[_c('img',{style:({
        width: _vm.idealSize.width + 'px',
        height: _vm.idealSize.height + 'px',
      }),attrs:{"crossOrigin":"","src":_vm.googleMapsURL}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }